import React from "react";
import PropTypes from "prop-types";

import {black500, greyishBlue600} from "assets/jss/main";

import {UserAgentUtils} from "utils/useragent";

function LegendItem({ label, color }) {
    const isMobile = UserAgentUtils.isMobile();

    return (
        <div style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
        }}>
            <div style={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor: color,
                flexShrink: 0,
            }} />
            <span style={{
                fontSize: isMobile ? '11px': '14px',
                fontWeight: isMobile ? 'normal' : 600,
                color: isMobile ? greyishBlue600 : black500,
            }}>
                {label}
            </span>
        </div>
    );
}

LegendItem.propTypes = {
    label: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
};

function ChartLegend({ onlineLegend, physicalLegend, showPhysical }) {
    return (
        <div style={{
            display: "flex",
            gap: "12px",
        }}>
            <LegendItem label={onlineLegend} color="#3C81FB" />
            {showPhysical && <LegendItem label={physicalLegend} color="#E697FF" />}
        </div>
    );
}

ChartLegend.propTypes = {
    onlineLegend: PropTypes.string.isRequired,
    physicalLegend: PropTypes.string,
    showPhysical: PropTypes.bool,
};

ChartLegend.defaultProps = {
    showPhysical: false,
};

export default ChartLegend;
